module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-word-8551b3227c2240162bd87602833ffdd0.svg";